import { observer } from 'mobx-react-lite'
import { Box, Scrollbar, Typography } from 'shared/ui'
import styles from 'pages/reviews/ui/Preview/styles.module.scss'
import { useReviewViewContext } from 'pages/reviews/context'
import { PreviewLogo } from 'pages/reviews/ui/Preview/PreviewLogo'
import { PreviewAccountItemEmpty } from 'pages/reviews/ui/Preview/PreviewAccountItemEmpty'
import { PreviewAccountItem } from 'pages/reviews/ui/Preview/PreviewAccountItem'

export const PreviewHappy = observer(() => {
  const { title, happySubtitle, accounts } = useReviewViewContext()

  return (
    <Scrollbar>
      <Box
        display={'flex'}
        justifyContent={'center'}
        flexDirection={'column'}
        padding={'48px 16px 16px'}
      >
        <PreviewLogo />
        <Box padding={'0 24px'} display={'flex'} flexDirection={'column'}>
          <Typography ariaLabel={'reviewTitle'} className={styles.title} marginBottom={7}>
            {title || 'Title'}
          </Typography>
          <Typography
            ariaLabel={'reviewSubtitle'}
            variant={'body-rg-medium'}
            className={styles.subtitle}
            marginBottom={32}
          >
            {happySubtitle || 'Subtitle'}
          </Typography>
        </Box>
        <Box display={'flex'} flexDirection={'column'} gap={'8px'}>
          {accounts.length === 0 && <PreviewAccountItemEmpty />}
          {accounts.map((account) => (
            <PreviewAccountItem key={account.key} account={account} />
          ))}
        </Box>
      </Box>
    </Scrollbar>
  )
})
